export default __webpack_public_path__ + "static/media/male.2392aa73.PNG";